

export default function SectionTwo () {
    return (
        <section className="w-screen h-full bg-white trig">

                <div className="lg:max-w-[82rem] lg:mx-auto">
                    <div className="grid lg:grid-cols-2 lg:gap-[3.5rem] w-full lg:py-[4rem]">

                        <div className="w-full lg:h-96 h-64 bg-cover bg-top s-two-image"
                            style={{ backgroundImage: `url("/com.JPG")` }}
                        ></div>

                        <div className="flex flex-col justify-center p-4 lg:p-0 s-two-desc">
                            <h3 className="lg:text-[38px] text-[22px] font-malaya text-[#1E2332] lg:pb-4 pb-1.5 flex gap-1.5">
                                <span>A community roundtable</span>
                            </h3>

                            <p className="lg:text-[18px] text-[15px] pb-2 lg:pb-0">
                                The New Rochelle Council of Community Services (NRCCS) is a non-profit organization whose mission is to bring together community leaders to assess and meet the vital needs of the community by identifying and working towards solutions through: mobilization, advocacy, and networking.
                            </p>
                        </div>
                    </div>
                </div>

        </section>
    )
}